// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Image_wrapper__md0qt","img":"Image_img__33hkl","skeleton":"Image_skeleton__1y084"};